import { Component, Input, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Branch } from 'src/app/core/interfaces/invoice.interface';
import { BranchService } from 'src/app/core/services/branch.service';
import { DropdownInputsSignalService } from 'src/app/core/services/dropdown-inputs-signal.service';
import { CompanyService } from 'src/app/modules/settings/services/company.service';
import { FiltersListService } from 'src/app/core/services/filters-list.service';

@Component({
  selector: 'app-branch-header',
  templateUrl: './branch-header.component.html',
  styleUrl: './branch-header.component.scss'
})
export class BranchHeaderComponent implements OnInit {
  @Input({ required: false }) branch?: any;
  private destroy$ = new Subject<void>();

  /** صورة ثابتة عند غياب شعار الشركة/الفرع — مسار مطلق ليعمل في الطباعة وجميع المسارات */
  logoSrc = '/assets/media/logos/company-placeholder.png';
  companyLogo?: string;
  companyName?: string;

  constructor(
    private filtersListService: FiltersListService,
    private signalService: DropdownInputsSignalService,
    private companyService: CompanyService,
  ) { }


  ngOnInit(): void {
    // // this.loadCurrent();

    this.signalService.reload$.subscribe((res) => {
      if (res === 'updateCompanyLogo') this.loadCurrent();
    })

    if (this.branch) return;

    setTimeout(() => {
      // this.loadBranches();
    });
  }

  /** تحميل بيانات الشركة الافتراضية (شعار + أسماء) من Structure/Company/default */
  loadCurrent() {
    this.companyService.getDefault(true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const company = res?.data;
          const logoUrl = company?.logoUrl ?? company?.logoAttachment?.url ?? company?.logoAttachment?.fullPath;
          if (logoUrl) this.companyLogo = logoUrl;

          const nameAr = company?.nameAr ?? '';
          const nameEn = company?.nameEn ?? '';

          if (nameAr && nameEn) {
            this.companyName = `${nameAr} - ${nameEn}`;
          } else if (nameAr) {
            this.companyName = nameAr;
          } else if (nameEn) {
            this.companyName = nameEn;
          } else {
            this.companyName = '';
          }
        },
        error: (err) => {
          console.log(err);
        }
      });
  }

  loadBranches() {
    this.filtersListService.getBranches().optionsFnc!(1, 1, '', [])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.branch = res[0];
        }
      })
  }

  /** عند فشل تحميل صورة الشعار (شركة/فرع) نعرض الشعار الثابت */
  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img && this.logoSrc) {
      img.src = this.logoSrc;
      img.onerror = null;
    }
  }
}
